import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Image, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../assets/logo-boulder.png';
import heroVideo from '../assets/video.mp4';
import '../css/home2.css';

export default function Home() {

    const whatsappLink = "https://wa.me/393755035466";

    // Import dinamico di tutte le foto dalla cartella photos/
    const photoContext = require.context('../assets/photos/', false, /\.(jpg|jpeg|png|webp)$/i);
    const photos = photoContext.keys().sort().map(photoContext);

    return (
        <>
            <Helmet>
                <title>Boulder 51 - La forza di spingerti oltre</title>
                <meta name="description" content="Boulder 51 - 350 m² di pareti boulder, trave, pan gullich, moonboard, spraywall e area potenziamento" />
            </Helmet>

            {/* HERO SECTION */}
            <section className="hero-section">
                <Container fluid={'md'} className='text-center text-light' style={{maxWidth: 1200}}>
                    <Image src={logo} width={'100%'} style={{maxWidth: 300}} className="mb-4" />

                    <h1 className="hero-title">
                        <span className="hero-subtitle">LA FORZA DI SPINGERTI OLTRE,<br/>UN BLOCCO ALLA VOLTA</span>
                    </h1>

                    {/* Video */}
                    <div className="video-container my-5">
                        <video
                            src={heroVideo}
                            autoPlay
                            muted
                            loop
                            playsInline
                            className="hero-video"
                        />
                    </div>

                    <div className="hero-features">
                        <p className="lead fw-bold">
                            350 m² di pareti Boulder, Trave, Pan Gullich,<br/>
                            Moonboard, Spraywall e Area Potenziamento
                        </p>
                        <p className="hero-tagline mt-4">
                            Un luogo dove allenarti, divertirti e superarti ogni settimana.
                        </p>
                    </div>
                </Container>
            </section>

            {/* PERCORSI SECTION */}
            <section className="percorsi-section py-5">
                <Container fluid={'md'} style={{maxWidth: 1200}}>
                    <Row className="g-4">
                        {/* Voglio iniziare a scalare */}
                        <Col xs={12} lg={6}>
                            <div className="percorso-card h-100">
                                <div className="percorso-header">
                                    <h3>VOGLIO INIZIARE A SCALARE</h3>
                                </div>
                                <div className="percorso-body">
                                    <h4 className="text-warning">CORSO BASE DI BOULDER</h4>
                                    <p className="subtitle">4 lezioni per iniziare a scalare</p>

                                    <p className="description">
                                        Il modo migliore per entrare nel mondo del Boulder.<br/>
                                        Un istruttore qualificato ti seguirà in gruppi da 3 a 6 persone.
                                    </p>

                                    <ul className="feature-list">
                                        <li><FontAwesomeIcon icon="calendar-alt" className="me-2" /> Durata: 4 settimane</li>
                                        <li><FontAwesomeIcon icon="clock" className="me-2" /> Lezioni: 1 a settimana da 90'</li>
                                        <li><FontAwesomeIcon icon="door-open" className="me-2" /> Accesso libero per il mese</li>
                                        <li><FontAwesomeIcon icon="shoe-prints" className="me-2" /> Scarpette incluse</li>
                                    </ul>

                                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="btn btn-warning btn-lg w-100 mt-4">
                                        <FontAwesomeIcon icon="brands fa-whatsapp" className="me-2" />
                                        Contattaci su WhatsApp
                                    </a>
                                </div>
                            </div>
                        </Col>

                        {/* Scalo già da solo */}
                        <Col xs={12} lg={6}>
                            <div className="percorso-card h-100">
                                <div className="percorso-header">
                                    <h3>SCALO GIÀ DA SOLO</h3>
                                </div>
                                <div className="percorso-body">
                                    <h4 className="text-warning">PER CHI SA GIÀ MUOVERSI SULLA PARETE</h4>

                                    <p className="description">
                                        Se conosci già le basi del Boulder, puoi allenarti in autonomia.<br/>
                                        Blocchi sempre nuovi e una community appassionata pronta a sfidarti.
                                    </p>

                                    <ul className="feature-list">
                                        <li><FontAwesomeIcon icon="mountain" className="me-2" /> 350 m² di pareti arrampicabili</li>
                                        <li><FontAwesomeIcon icon="dumbbell" className="me-2" /> Trave, Moonboard e area potenziamento con manubri, KB, sbarra, anelli, bilanciere</li>
                                        <li><FontAwesomeIcon icon="rocket" className="me-2" /> Spraywall e Pan Gullich in arrivo</li>
                                        <li><FontAwesomeIcon icon="sync" className="me-2" /> Ritracciatura ogni 3 settimane</li>
                                    </ul>

                                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="btn btn-warning btn-lg w-100 mt-4">
                                        <FontAwesomeIcon icon="brands fa-whatsapp" className="me-2" />
                                        Contattaci su WhatsApp
                                    </a>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* BOULDER COS'È SECTION */}
            <section className="boulder-cose-section py-5">
                <Container fluid={'md'} className="text-center text-light" style={{maxWidth: 900}}>
                    <h2 className="section-title mb-4">BOULDER: COS'È?</h2>

                    <div className="boulder-description">
                        <p className="lead fw-bold">
                            Il Boulder è libertà.<br/>
                            È sfida pura.
                        </p>

                        <p className="mt-4">
                            Niente corde, niente scuse.<br/>
                            Solo tu, la parete e la voglia di arrivare in cima.
                        </p>

                        <p className="mt-4">
                            Ogni blocco è un puzzle fisico e mentale: devi leggere i movimenti,
                            fidarti delle mani, cadere e riprovare.
                        </p>

                        <p className="mt-4">
                            Le nostre pareti arrivano fino a <strong>4 metri d'altezza</strong> con
                            materassi di protezione sotto ogni blocco.
                        </p>

                        <p className="mt-4 highlight-text">
                            È adrenalina, concentrazione e divertimento in pochi metri di parete.
                        </p>

                        <p className="mt-5 fw-bold boulder-motto">
                            Ti alleni, ti scarichi, ti superi.<br/>
                            <span className="text-warning">Questo è il Boulder.</span>
                        </p>
                    </div>
                </Container>
            </section>

            {/* GALLERY SECTION */}
            <section className="gallery-section py-5">
                <Container fluid={'md'} style={{maxWidth: 1200}}>
                    <h2 className="section-title text-center text-light mb-5">GALLERY</h2>
                    <Row className="g-3">
                        {photos.map((photo, index) => (
                            <Col xs={6} md={3} key={index}>
                                <Image src={photo} width={'100%'} className="gallery-img" />
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* INSIDE GATE 51 SECTION */}
            <section className="inside-section py-5">
                <Container fluid={'md'} className="text-center text-light" style={{maxWidth: 1000}}>
                    <h2 className="section-title mb-4">INSIDE GATE 51</h2>

                    <p className="lead">
                        Nel 2025 Gate 51 si espande con un progetto dedicato solo al Boulder.
                    </p>

                    <p className="mt-4">
                        Una nuova area pensata per portare la filosofia del movimento funzionale
                        e della community Gate51 anche nel mondo dell'arrampicata.
                    </p>

                    <div className="partner-info mt-5">
                        <p>
                            Un'area realizzata da <strong>Citywall</strong>: massima affidabilità.
                        </p>
                        <p className="mt-3">
                            Selezione di prese e volumi firmata <strong>Infinity</strong>, <strong>Cyta Climbs</strong>,
                            <strong> Illusion</strong>, <strong>360</strong> per blocchi qualitativamente al top.
                        </p>
                    </div>
                </Container>
            </section>

            {/* ACCANTO ALL'AREA BL SECTION */}
            <section className="accanto-section py-5">
                <Container fluid={'md'} className="text-center text-light" style={{maxWidth: 1000}}>
                    <h2 className="section-title mb-4">ACCANTO ALL'AREA BOULDER TROVERAI</h2>

                    <Row className="g-4 mt-4">
                        <Col xs={12} md={4}>
                            <div className="accanto-card">
                                <FontAwesomeIcon icon="dumbbell" size="3x" className="text-warning mb-3" />
                                <h4>850 m²</h4>
                                <p>di Gate51 CF & HY<br/>Il nostro centro per l'allenamento funzionale</p>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="accanto-card">
                                <FontAwesomeIcon icon="heart-pulse" size="3x" className="text-warning mb-3" />
                                <h4>150 m²</h4>
                                <p>di Health51</p>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="accanto-card">
                                <FontAwesomeIcon icon="users" size="3x" className="text-warning mb-3" />
                                <h4>Un unico spazio</h4>
                                <p>Tre anime</p>
                            </div>
                        </Col>
                    </Row>

                    <div className="cta-buttons mt-5">
                        <a href="#orari" className="btn btn-outline-warning btn-lg me-3 mb-2">
                            <FontAwesomeIcon icon="clock" className="me-2" />
                            Orari
                        </a>
                        <a href="#prezzi" className="btn btn-outline-warning btn-lg mb-2">
                            <FontAwesomeIcon icon="tag" className="me-2" />
                            Prezzi
                        </a>
                    </div>
                </Container>
            </section>

            {/* PROGRAMMI SPECIALI SECTION */}
            <section className="programmi-section py-5">
                <Container fluid={'md'} style={{maxWidth: 1200}}>
                    <h2 className="section-title text-center text-light mb-5">PROGRAMMI SPECIALI</h2>

                    <Row className="g-4">
                        {/* Boulder Kids */}
                        <Col xs={12} md={6}>
                            <div className="programma-card">
                                <div className="programma-icon">
                                    <FontAwesomeIcon icon="child" size="3x" />
                                </div>
                                <h3 className="text-warning">BOULDER KIDS</h3>
                                <p className="tagline">Divertimento, movimento e fiducia.<br/>Un blocco alla volta.</p>

                                <ul className="feature-list mt-4">
                                    <li><FontAwesomeIcon icon="calendar-week" className="me-2" /> 1 lezione a settimana</li>
                                    <li><FontAwesomeIcon icon="clock" className="me-2" /> 90 minuti</li>
                                    <li><FontAwesomeIcon icon="child" className="me-2" /> Dai 6 agli 11 anni</li>
                                </ul>

                                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="btn btn-warning btn-lg w-100 mt-4">
                                    <FontAwesomeIcon icon="brands fa-whatsapp" className="me-2" />
                                    Contattaci
                                </a>
                            </div>
                        </Col>

                        {/* Personal BL */}
                        <Col xs={12} md={6}>
                            <div className="programma-card">
                                <div className="programma-icon">
                                    <FontAwesomeIcon icon="user-graduate" size="3x" />
                                </div>
                                <h3 className="text-warning">PERSONAL BL</h3>
                                <p className="tagline">Allenamenti Personalizzati</p>

                                <p className="description mt-4">
                                    Allenamenti su misura per iniziare o portare la tua scalata a un altro livello.
                                </p>

                                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="btn btn-warning btn-lg w-100 mt-4">
                                    <FontAwesomeIcon icon="brands fa-whatsapp" className="me-2" />
                                    Contattaci
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* CURIOSITÀ SECTION */}
            <section className="curiosita-section py-5">
                <Container fluid={'md'} className="text-center text-light" style={{maxWidth: 800}}>
                    <h2 className="section-title mb-4">HAI CURIOSITÀ?</h2>
                    <p className="lead mb-4">
                        Scrivici su WhatsApp per qualsiasi domanda!
                    </p>
                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="btn btn-warning btn-lg">
                        <FontAwesomeIcon icon="brands fa-whatsapp" className="me-2" />
                        Contattaci su WhatsApp
                    </a>
                </Container>
            </section>

            {/* ORARI SECTION */}
            <section id="orari" className="orari-section py-5">
                <Container fluid={'md'} className="text-center text-light" style={{maxWidth: 800}}>
                    <h2 className="section-title mb-5">ORARI</h2>

                    <div className="orari-grid">
                        <div className="orario-item">
                            <span className="giorno">LUN - MAR - GIOV</span>
                            <span className="ore">7:00 - 22:00</span>
                        </div>
                        <div className="orario-item">
                            <span className="giorno">MERC - VEN</span>
                            <span className="ore">11:00 - 22:00</span>
                        </div>
                        <div className="orario-item">
                            <span className="giorno">SAB</span>
                            <span className="ore">
                                10:15 - 13:15
                                <br/>
                                15:00 - 18:30
                                <br/>
                                <span style={{ fontSize: 8 }}>orario continuato variabile</span>
                            </span>
                        </div>
                        <div className="orario-item">
                            <span className="giorno">DOM</span>
                            <span className="ore">14:30 - 18:00</span>
                        </div>
                    </div>
                </Container>
            </section>

            {/* PREZZI SECTION */}
            <section id="prezzi" className="prezzi-section py-5">
                <Container fluid={'md'} className="text-center text-light" style={{maxWidth: 1000}}>
                    <h2 className="section-title mb-5">PREZZI</h2>

                    <Row className="g-4 mb-4">
                        {/* Abbonamenti Boulder */}
                        <Col xs={12} md={6}>
                            <div className="prezzo-card prezzo-card-abbonamenti h-100">
                                <h3 className="prezzo-card-title-alt">ABBONAMENTI</h3>

                                <div className="prezzo-abbonamento-list">
                                    <div className="prezzo-abbonamento-item">
                                        <span className="prezzo-periodo">1 MESE</span>
                                        <span className="prezzo-amount-alt">75€</span>
                                    </div>
                                    <div className="prezzo-abbonamento-item">
                                        <span className="prezzo-periodo">3 MESI</span>
                                        <span className="prezzo-amount-alt">195€</span>
                                        <span className="prezzo-dettaglio">(65€/mese)</span>
                                    </div>
                                    <div className="prezzo-abbonamento-item">
                                        <span className="prezzo-periodo">6 MESI</span>
                                        <span className="prezzo-amount-alt">350€</span>
                                        <span className="prezzo-dettaglio">(58€/mese)</span>
                                    </div>
                                    <div className="prezzo-abbonamento-item">
                                        <span className="prezzo-periodo">12 MESI</span>
                                        <span className="prezzo-amount-alt">580€</span>
                                        <span className="prezzo-dettaglio">(48€/mese)</span>
                                    </div>
                                </div>

                                <p className="prezzo-bonus mt-3">+1 MESE OMAGGIO CROSSFIT</p>
                            </div>
                        </Col>

                        {/* Ingressi Singoli Boulder */}
                        <Col xs={12} md={6}>
                            <div className="prezzo-card prezzo-card-ingressi h-100">
                                <h3 className="prezzo-card-title-alt">INGRESSI SINGOLI</h3>

                                <div className="prezzo-abbonamento-list">
                                    <div className="prezzo-abbonamento-item">
                                        <span className="prezzo-periodo">ADULTO</span>
                                        <span className="prezzo-amount-alt">12€</span>
                                    </div>
                                    <div className="prezzo-abbonamento-item">
                                        <span className="prezzo-periodo">11-16 ANNI</span>
                                        <span className="prezzo-amount-alt">10€</span>
                                    </div>
                                    <div className="prezzo-abbonamento-item">
                                        <span className="prezzo-periodo">7-10 ANNI</span>
                                        <span className="prezzo-amount-alt">7€</span>
                                    </div>
                                    <div className="prezzo-abbonamento-item">
                                        <span className="prezzo-periodo">10 INGRESSI (6 MESI)</span>
                                        <span className="prezzo-amount-alt">105€</span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <p className="text-light small mb-4">Noleggio scarpette 4€</p>

                    <Row className="g-4 mb-5">
                        {/* Colonna sinistra: Corsi */}
                        <Col xs={12} md={6}>
                            {/* Corso Base Boulder */}
                            <div className="prezzo-card mb-4">
                                <h3 className="prezzo-card-title">CORSO BASE BOULDER</h3>
                                <p className="prezzo-card-subtitle">(4 LEZ. - 90') <span className="prezzo-amount">110€</span></p>
                                <p className="prezzo-card-detail">Compreso 1 mese con ingressi liberi</p>
                                <p className="prezzo-card-detail">Noleggio scarpette incluso</p>
                            </div>

                            {/* Corso Kids Boulder */}
                            <div className="prezzo-card prezzo-card-kids">
                                <h3 className="prezzo-card-title">CORSO KIDS BOULDER</h3>
                                <p className="prezzo-card-subtitle"><span className="prezzo-amount">160€</span></p>
                                <p className="prezzo-card-detail">(1 lezione a settimana) - <strong>3 mesi</strong></p>
                                <p className="prezzo-card-detail">Martedì o Giovedì 16:30 - 18:00</p>
                            </div>
                        </Col>

                        {/* Colonna destra: Lezioni Individuali */}
                        <Col xs={12} md={6}>
                            <div className="prezzo-card h-100">
                                <h3 className="prezzo-card-title">LEZIONI INDIVIDUALI BOULDER</h3>
                                <p className="prezzo-card-label">(PREZZO A PERSONA)</p>

                                <div className="prezzo-individuale-list">
                                    <div className="prezzo-individuale-item">
                                        <span className="prezzo-persone">1 PERSONA</span>
                                        <span className="prezzo-amount">40€</span>
                                    </div>
                                    <div className="prezzo-individuale-item">
                                        <span className="prezzo-persone">2 PERSONE</span>
                                        <span className="prezzo-amount">35€</span>
                                    </div>
                                    <div className="prezzo-individuale-item">
                                        <span className="prezzo-persone">3 PERSONE</span>
                                        <span className="prezzo-amount">30€</span>
                                    </div>
                                    <div className="prezzo-individuale-item">
                                        <span className="prezzo-persone">4 PERSONE</span>
                                        <span className="prezzo-amount">25€</span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <p className="lead">
                        Contattaci per conoscere i nostri pacchetti e le promozioni attive!
                    </p>
                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="btn btn-warning btn-lg mt-3">
                        <FontAwesomeIcon icon="brands fa-whatsapp" className="me-2" />
                        Richiedi Info Prezzi
                    </a>
                </Container>
            </section>

            {/* CONTATTI FOOTER */}
            <section className="contatti-section py-5">
                <Container fluid={'md'} className="text-center text-light" style={{maxWidth: 800}}>
                    <h2 className="section-title mb-4">DOVE SIAMO</h2>
                    <p className="lead">
                        <FontAwesomeIcon icon="map-marker-alt" className="me-2 text-warning" />
                        Via Venezia, 53, 31020 San Vendemiano (TV)
                    </p>
                    <p className="mt-3">
                        <FontAwesomeIcon icon="phone" className="me-2 text-warning" />
                        <a href="tel:+393755035466" className="text-light">375 503 5466</a>
                    </p>
                    <p>
                        <FontAwesomeIcon icon="envelope" className="me-2 text-warning" />
                        <a href="mailto:gate51boulder@gmail.com" className="text-light">gate51boulder@gmail.com</a>
                    </p>
                </Container>
            </section>
        </>
    );
}
